__turbopack_context__.v({
  "checkbox": "accountLogin-module-scss-module__MG-Axq__checkbox",
  "checkboxWrapper": "accountLogin-module-scss-module__MG-Axq__checkboxWrapper",
  "forgotPassword": "accountLogin-module-scss-module__MG-Axq__forgotPassword",
  "formColumns": "accountLogin-module-scss-module__MG-Axq__formColumns",
  "inlineValidationError": "accountLogin-module-scss-module__MG-Axq__inlineValidationError",
  "loginButton": "accountLogin-module-scss-module__MG-Axq__loginButton",
  "passwordWrapper": "accountLogin-module-scss-module__MG-Axq__passwordWrapper",
  "toggleVisibility": "accountLogin-module-scss-module__MG-Axq__toggleVisibility",
  "wrapper": "accountLogin-module-scss-module__MG-Axq__wrapper",
});
